// extracted by mini-css-extract-plugin
module.exports = {"healthbg":"health_healthbg__2gxrM","healthStyle":"health_healthStyle__dROOf","healthnews":"health_healthnews__2Lo7e","underline":"health_underline__3pRZ2"};